<template>
  <v-flex md12>
    <material-card color="blue" title="Dados do Lead" text="">
      <v-form>
        <v-container py-0>
          <v-layout wrap>
            <v-flex xs12 md4>
              <v-text-field
                v-model.lazy="lead.email"
                :rules="emailRules"
                label="*E-mail"
                prepend-icon="email"
                name="email"
                type="email"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                v-model="lead.name"
                name="name"
                label="*Nome Completo"
                prepend-icon="person"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <!-- <v-autocomplete
                        :items="states"
                        item-text="name"
                        item-value="initials"
                        label="Estado"
                        prepend-icon="map"
                        v-model.lazy="lead.state"
                        return-object
                        :rules="[v => !!v || 'Por favor, selecione o seu estado!']"
                        :hint="'Selecione o estado'"
                        required
                    ></v-autocomplete> -->
              <v-text-field
                v-model="lead.concessionaria"
                name="concessionaria"
                label="Concessionaria"
                required
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                v-model="lead.phone"
                name="phone"
                label="*Celular"
                return-masked-value
                mask="(##) #####-####"
                prepend-icon="phone"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                v-model="lead.promo_code"
                label="Código de Indicação"
                prepend-icon="record_voice_over"
                hint="um amigo(a) lhe indicou? Informe o código aqui"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                id="average_consumption"
                v-model.lazy="lead.average_consumption"
                prefix="R$"
                label="Média de Consumo"
                return-masked-value
                mask="########"
                required
                @change="changeAverage()"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
              <v-text-field
                id="cpf"
                v-model="lead.cpf"
                label="CPF/CNPJ"
                return-masked-value
                :v-mask="['###.###.###-##', '##.###.###/####-##']"
                required
              ></v-text-field>
              <!-- <the-mask 
                        id="cpf"
                        v-model="lead.cpf"
                        label="CPF/CNPJ"
                        required
                        :mask="['###.###.###-##', '##.###.###/####-##']" 
                    /> -->
            </v-flex>
            <v-flex xs12 md2>
              <v-expansion-panel
                v-model="panel"
                expand
                class="elevation-0"
                v-if="lead.tracking && lead.tracking.length > 0"
              >
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <h3>Tracking</h3>
                  </template>
                  <v-card>
                    <v-data-table
                      :headers="headers"
                      :items="lead.tracking"
                      class="elevation-0"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.created_at | formatarDateTime }}</td>
                        <td class="text-xs-right">
                          {{ props.item.utm_source }}
                        </td>
                        <td class="text-xs-right">
                          {{ props.item.utm_medium }}
                        </td>
                        <td class="text-xs-right">
                          {{ props.item.utm_campaign }}
                        </td>
                        <td class="text-xs-right">{{ props.item.utm_term }}</td>
                        <td class="text-xs-right">
                          {{ props.item.utm_content }}
                        </td>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- <label class="label">Origem do Lead:</label> {{lead.utm_source}} -->
            </v-flex>
            <!-- <v-flex
                    xs12
                    md2
                >
                    <label class="label">Meio de Origem:</label> {{lead.utm_medium}}
                </v-flex>
                <v-flex
                    xs12
                    md2
                >
                    <label class="label">Campanha:</label> {{lead.utm_campaign}}
                </v-flex> -->
            <v-flex xs12 md12 text-xs-right>
              <v-btn
                class="mx-0 font-weight-light"
                color="success"
                :loading="loading"
                :disabled="loading"
                @click.prevent="storeLead(mode, lead)"
              >
                <v-icon left dark>add</v-icon>
                Salvar
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </material-card>
    <v-snackbar
      :color="snack.color"
      :bottom="snack.bottom"
      :top="snack.top"
      :left="snack.left"
      :right="snack.right"
      v-model="snack.snackbar"
      dark
    >
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snack.snackMessage }}</div>
      <v-icon size="16" @click="snack.snackbar = false">
        mdi-close-circle
      </v-icon>
    </v-snackbar>
  </v-flex>
</template>
<script>
import statesfile from "@/model/state";
import { eventBus } from "../../main";
import { mask } from "vue-the-mask";

// import { addLead, updateLead } from '../../services/leads'
import { CREATE_LEAD, UPDATE_LEAD } from "../../graphql/leads";

export default {
  data: function () {
    return {
      emailRules: [],
      rules: [],
      states: statesfile.estados,
      lead: {},
      mode: "new",
      snack: {
        color: null,
        top: true,
        bottom: false,
        left: false,
        right: false,
        snackMessage: "",
        snackbar: false,
      },
      loading: false,
      headers: [
        {
          text: "Data",
          align: "left",
          sortable: true,
          value: "created_at",
          sortDesc: false,
        },
        { text: "Fonte", value: "utm_source" },
        { text: "Meio", value: "utm_medium" },
        { text: "Campanha", value: "utm_campanha" },
        { text: "Termo", value: "utm_term" },
        { text: "Conteúdo", value: "utm_content" },
      ],
      sortDesc: true,
      panel: [true],
    };
  },
  directives: { mask },
  created() {
    eventBus.$on("leadSelected", (lead) => {
      this.lead = lead;
      this.mode = "edit";
    });
  },
  methods: {
    changeAverage: function () {
      eventBus.$emit("leadSelected", this.lead);
      // console.log(this.lead.average_consumption)
    },
    storeLead(mode, lead) {
      let query;
      if (mode === "new") {
        query = CREATE_LEAD;
      } else {
        query = UPDATE_LEAD;
      }
      const newState = {
        initials: lead.state.initials,
        name: lead.state.name,
      };
      this.$apollo
        .mutate({
          // Query
          mutation: query,
          // Parameters
          variables: {
            id: lead.email,
            email: lead.email,
            name: lead.name,
            cpf: lead.cpf,
            phone: lead.phone,
            average_consumption: lead.average_consumption,
            step: 1,
            promo_code: lead.promo_code,
            state: newState,
          },
        })
        .then(() => {
          this.loading = false;
          this.show_snack(
            "Dados principais do lead gravados com sucesso!",
            "success",
            "top",
          );
        })
        .catch((error) => {
          this.loading = false;
          this.show_snack(
            "Erro ao gravar lead. " + error.message,
            "error",
            "top",
          );
        });
      // if(this.newLead) {
      //     addLead(lead)
      //         .then((res) => {
      //             this.loading = res.loading
      //             this.show_snack('Dados principais do lead criados com sucesso!','success','top')
      //         })
      //         .catch(error => {
      //             this.loading = false
      //             this.show_snack(error.message, 'error','top')
      //         })
      // } else {
      //     updateLead(id, lead)
      //         .then((res) => {
      //             this.loading = res.loading
      //             this.show_snack('Dados principais do lead atualizados com sucesso!','success','top')
      //         })
      //         .catch(error => {
      //             this.loading = false
      //             this.show_snack(error.message, 'error','top')
      //         })
      // }
    },
    show_snack(message, color, ...args) {
      this.snack.top = false;
      this.snack.bottom = false;
      this.snack.left = false;
      this.snack.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.snack.color = color;
      this.snack.snackMessage = message;
      this.snack.snackbar = true;
    },
  },
};
</script>
<style scoped>
.label {
  font-weight: 600;
}
</style>
